import { AbstractFormArgument } from './global'

class FormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.createTime = ''
    this.creater = ''
    this.crmCode = ''
    this.id = ''
    this.param1 = ''
    this.param2 = ''
    this.param3 = ''
    this.param4 = ''
    this.param5 = ''
    this.param6 = ''
    this.param7 = ''
    this.param8 = ''
    this.param9 = ''
    this.param10 = ''
    this.channelSourceName = ''
    this.sync = ''
    this.wyCustomerId = ''
  }
}

class FieldFormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.itemName = ''
    this.appId = ''
    this.appsecret = ''
  }
}

class CopyFormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.date = ''
    this.dateList = ''
    this.crmCode = ''
  }
}

class staffFormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.date = ''
    this.itemId = ''
    this.userId = ''
    this.crmCode = ''
  }
}

class saveFormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.datalist = ''
  }
}

class dateArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.itemsId = ''
    this.crmCode = ''
  }
}

export {
  FormArgument,
  FieldFormArgument,
  CopyFormArgument,
  staffFormArgument,
  dateArgument,
  saveFormArgument
}



// WEBPACK FOOTER //
// ./src/models/ec-setting.js